import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dodao-ui/dodao-ui/academy-ui/src/components/byteCollection/View/ByteCollectionsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SetupNewSpaceButton"] */ "/home/runner/work/dodao-ui/dodao-ui/academy-ui/src/components/home/common/setupNewSpace.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WatchVideoButton"] */ "/home/runner/work/dodao-ui/dodao-ui/academy-ui/src/components/home/common/WatchVideoButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LottieAnimation"] */ "/home/runner/work/dodao-ui/dodao-ui/academy-ui/src/components/home/DefaultHome/LottieAnimation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PrimaryFeatures"] */ "/home/runner/work/dodao-ui/dodao-ui/academy-ui/src/components/home/TidbitsHub/components/PrimaryFeatures.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/dodao-ui/dodao-ui/academy-ui/src/components/main/HomeIcon.module.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/dodao-ui/dodao-ui/academy-ui/src/images/DAO/AAVE.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/dodao-ui/dodao-ui/academy-ui/src/images/DAO/Alchemix.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/dodao-ui/dodao-ui/academy-ui/src/images/DAO/Arbitrum.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/dodao-ui/dodao-ui/academy-ui/src/images/DAO/Balancer.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/dodao-ui/dodao-ui/academy-ui/src/images/DAO/Compound.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/dodao-ui/dodao-ui/academy-ui/src/images/DAO/Fuel.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/dodao-ui/dodao-ui/academy-ui/src/images/DAO/Harmony.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/dodao-ui/dodao-ui/academy-ui/src/images/DAO/Near.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/dodao-ui/dodao-ui/academy-ui/src/images/DAO/Optimism.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/dodao-ui/dodao-ui/academy-ui/src/images/DAO/Uniswap.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/dodao-ui/dodao-ui/node_modules/.pnpm/next@15.5.27_@babel+core@7.29.0_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.97.3/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/dodao-ui/dodao-ui/node_modules/.pnpm/next@15.5.27_@babel+core@7.29.0_supports-color@8.1.1__react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.97.3/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/dodao-ui/dodao-ui/shared/web-core/src/components/home/common/GetStartedButton.module.scss");
